module.exports = __webpack_public_path__ + "static/media/Dolores Umbridge 2.a8b156f4.jpg";